module.exports = __webpack_public_path__ + "static/media/Ryan Banfill Headshot.30a90be3.jpeg";